import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TvoedSalaryCalculatorModule } from '@metallgehalt/tvoed-salary-calculator';

import { TvoedSalaryRoutingModule } from './tvoed-salary-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, TvoedSalaryCalculatorModule, TvoedSalaryRoutingModule]
})
export class TvoedSalaryModule {}
